import api from "../../providers/api"
import history from "../../providers/history"
import { GetObject } from "../../providers/storage"
import { IAuthenticatedUser } from "../authentication/types"
import { IPaginations, IRoomWorkRegisterRequestPayload, ISweepSaveGuestRequestPayload, ISweepSaveRequestPayload, ISweepSaveRoomItemRequestPayload, ISweepSaveRoomRequestPayload, ISweepWorkRegisterRequestPayload } from "./types"

export const sweepsListRequestService = (filter?: IPaginations) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    let query = new URLSearchParams({
        limit: String(filter?.limit || ""),
        page: String(filter?.page || ""),
        isArchived: filter?.isArchived ? "true" : ""
    }).toString()

    return api.get(`sweeps/?${query}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}


export const sweepsSaveRequestService = (sweep: ISweepSaveRequestPayload, id?: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`sweeps/${id}`, sweep, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('sweeps', sweep, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const sweepsRemoveRequestService = (sweepId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`sweeps/${sweepId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}

export const sweepExportService = (sweepId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`sweeps/${sweepId}/export`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
        responseType: 'blob',
        timeout: 0
    })

}

export const sweepArchiveService = (sweepId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`sweeps/${sweepId}/archive`, null, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const sweepUnarchiveService = (sweepId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`sweeps/${sweepId}/unarchive`, null, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// EXPORT PHOTOS
export const roomExportPhotosService = (idRoom: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`room/${idRoom}/export-photos`, {
        responseType: 'blob',
        timeout: 0,
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
    })
}

// EXPORT FLIR
export const roomExportFlirRequestService = (idRoom: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`room/${idRoom}/export-flir`, {
        responseType: 'blob',
        timeout: 0,
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
    })
}

//EXPORT VIDEOS
export const roomExportVideoRequestService = (idRoom: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.get(`room/${idRoom}/export-videos`, {
        responseType: 'blob',
        timeout: 0,
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        },
    })
}


// ROOM
export const sweepsRoomSaveRequestService = (room: ISweepSaveRoomRequestPayload, id?: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`rooms/${id}`, room, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('rooms/', room, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const sweepsRoomRemoveRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/${roomId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}
// FLOORPLAN *** UPLOAD ***
export const roomFloorPlanSaveRequestService = (roomId: string, floorPLan: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/floor-plan/${roomId}/${floorPLan}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
// FLOORPLAN *** DELETE ***
export const roomFloorPlanDeleteRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/floor-plan/${roomId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// FREQUENCY FILE *** UPLOAD ***
export const roomFrequencyFileSaveRequestService = (roomId: string, frequencyFile: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/frequency-file/${roomId}/${frequencyFile}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}
export const roomFrequencyFileDeleteRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/frequency-file/${roomId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}
// ROOM ITEM
export const sweepsRoomItemSaveRequestService = (item: ISweepSaveRoomItemRequestPayload, id?: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (id) {
        return api.put(`items/${id}`, item, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post('items/', item, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const sweepsRoomItemRemoveRequestService = (itemId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`items/${itemId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}

// GUESTS
export const sweepsGuestSaveRequestService = (guest: ISweepSaveGuestRequestPayload) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    if (guest.guest.id && guest.guest.id !== "") {
        return api.put(`/sweeps/guest-member/${guest.sweepId}/${guest.guest.id}`, guest, {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
    }

    return api.post(`/sweeps/guest-member/${guest.sweepId}`, guest, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

export const sweepsGuestRemoveRequestService = (guestId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`sweeps/guest-member/${guestId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}

// *** FREQUENCY ANALYSIS | UPLOAD **** 
export const roomFrequencyAnalysisSaveRequestService = (roomId: string, frequencyAnalysis: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.put(`rooms/frequency-analysis/${roomId}/${frequencyAnalysis}`, null,
        {
            headers: {
                Authorization: `Bearer ${authenticatedUser.token}`
            }
        })
}

// *** FREQUENCY ANALYSIS | DELETE ***
export const roomFrequencyAnalysisDeleteRequestService = (roomId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/frequency-analysis/${roomId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

// *** SWEEP WORK REGISTER || ADD ***

export const sweepsWorkRegisterSaveRequestService = (register: ISweepWorkRegisterRequestPayload, sweepId: string) => {

    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.post(`sweeps/work-register/${sweepId}`, register, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

// *** SWEEP WORK REGISTER || REMOVE ***

export const sweepsWorkRegisterRemoveRequestService = (workRegisterId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`sweeps/work-register/${workRegisterId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}

// *** SWEEP WORK REGISTER || ADD ***

export const roomsWorkRegisterSaveRequestService = (register: IRoomWorkRegisterRequestPayload) => {

    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.post(`rooms/work-register/${register.roomId}`, register, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })
}

// *** SWEEP WORK REGISTER || REMOVE ***

export const roomsWorkRegisterRemoveRequestService = (workRegisterId: string) => {
    const authenticatedUser = GetObject<IAuthenticatedUser>('authenticatedUser');

    if (!authenticatedUser) return history.replace('/login');

    return api.delete(`rooms/work-register/${workRegisterId}`, {
        headers: {
            Authorization: `Bearer ${authenticatedUser.token}`
        }
    })

}